import { Controller, useFormContext } from 'react-hook-form';

import TextField from '@mui/material/TextField';

// ----------------------------------------------------------------------

export function RHFTextField({
  name,
  helperText,
  type,
  tabIndex,
  slotProps,
  handleOnChange = null,
  ...other
}) {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <TextField
          {...field}
          fullWidth
          type={type}
          value={field.value}
          onChange={(event) => {
            const value =
              type === 'number' && event.target.value !== ''
                ? Number(event.target.value)
                : event.target.value;

            field.onChange(value);
            handleOnChange && handleOnChange(value);
          }}
          error={!!error}
          helperText={error?.message ?? helperText}
          {...other}
          slotProps={{
            ...slotProps,
            htmlInput: {
              autoComplete: 'off',
              onWheel: (e) => e.target.blur(),
              tabIndex,
              ...slotProps?.htmlInput,
            },
          }}
        />
      )}
    />
  );
}
